import React, { useEffect, useRef } from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Footer = ({ responses }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [responses]);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#f9f9f9',
        padding: 1,
        borderTop: '1px solid #ddd',
        zIndex: 10,
      }}
    >
      <Paper
        ref={scrollRef}
        sx={{ padding: 1, maxHeight: '100px', overflow: 'auto' }}
      >
        <Typography variant="subtitle1">Sent Responses:</Typography>
        {responses && responses.length > 0 ? (
          responses.map((response, idx) => (
            <Typography key={idx} variant="body2">
              - {response}
            </Typography>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary">
            No responses yet.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default Footer;
